// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const processTemplateLiterals = (value: string | number, model: any): string | number | null => {
    if (!value || typeof value === 'number') return value
    const modelKeys = Object.keys(model)
    const templateLiterals: string[] = value.match(/{([^}]+)}/g) ?? []

    templateLiterals.map((templateLiteral: string) => {
        const modelField = templateLiteral.replaceAll('{', '').replaceAll('}', '')
        if (modelKeys.includes(modelField)) {
            value = value.toString().replace(`${templateLiteral}`, model[modelField])
        }
    })

    return value
}
